import { customListSchema, workSchema } from '@/app/permissions/models.ts'
import { z } from 'zod'

const curdPermissionSchema = z.union([
  z.literal('show'),
  z.literal('use'),
  z.literal('create'),
  z.literal('manage'),
  z.literal('edit'),
  z.literal('delete'),
])

export const workSubject = z.tuple([curdPermissionSchema, z.union([z.literal('work'), workSchema])])

export type WorkSubject = z.infer<typeof workSubject>

export const customListSubject = z.tuple([curdPermissionSchema, z.union([z.literal('custom-list'), customListSchema])])

export type CustomListActions = z.infer<typeof curdPermissionSchema>
export type CustomListSubject = z.infer<typeof customListSubject>

export const customSubjects = z.union([
  z.tuple([z.literal('manage'), z.literal('all')]),
  z.tuple([z.literal('show'), z.literal('telegram-button')]),
  z.tuple([z.literal('show'), z.literal('subscriber-indicator')]),
  z.tuple([z.literal('show'), z.literal('sync-notion-button')]),
  z.tuple([z.literal('show'), z.literal('rsync-works-button')]),
  z.tuple([z.literal('show'), z.literal('show-rsync-work-button-table')]),
  z.tuple([z.literal('show'), z.literal('show-rsync-work-button')]),
  z.tuple([z.literal('show'), z.literal('show-calendar-feature')]),
  z.tuple([z.literal('show'), z.literal('admin-section')]),
  z.tuple([z.literal('show'), z.literal('scrapping-report-feature')]),
  z.tuple([z.literal('show'), z.literal('email-not-confirmed-indicator')]),
])
